<template>
  <div class="padding-10">
    <v-card :elevation="$root.ele">
      <v-card-text class="pb-2 pt-2">
        <v-row>
          <v-col cols="12" sm="3">
            <date-range
              :clearable="false"
              v-model="date"
              label="Date Range (Job Create Date)"
            />
          </v-col>
          <v-col cols="12" sm="5">
            <v-autocomplete
              label="Select a Field"
              item-text="name"
              outlined
              multiple
              dense
              hide-details=""
              v-model="field"
              item-value="id"
              :items="fields"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" class="d-flex align-center justify-end flex-wrap">
            <v-btn
              color="grey"
              @click="reset()"
              outlined
              tile
              height="40px"
              depressed
              width="100"
              >Reset</v-btn
            >
            <v-btn
              text
              class="primary ml-2"
              tile
              width="100"
              @click="submit()"
              height="40px"
            >
              Apply</v-btn
            >
            <v-btn
              color="primary"
              depressed
              tile
              height="40px"
              class="font-weight-large ml-2"
              style="min-width: 40px !important; padding: 0 !important;"
              :disabled="!list.length"
              @click="exportPdf()"
            >
              <v-icon>mdi-download-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card :elevation="$root.ele" class="mt-4">
<v-data-table :headers="headers" :items="list" class="templates-table">
        <template v-slot:item.action="{ item }">
          <search-engine-jobs
            v-if="!item.catalog"
            :field="fieldItem"
            :item="item"
            :range="range"
          ></search-engine-jobs>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import DateRange from "../components/DateRange.vue";
import { customers } from "../assets/js/firebase";
import { formatDateOnly } from "../assets/js/common";
import SearchEngineJobs from "../components/searchEngine/SearchEngineJobs.vue";
import customerModal from "../assets/js/customer.modal";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
  components: { DateRange, SearchEngineJobs },
  data() {
    return {
      date: [],
      field: [],
      jobs: [],
      appliedFields: [],
      stockRows: [],
      keyRows: [],
      keyLabel: ""
    };
  },
  computed: {
    fields() {
      let { globalFields, serviceFields } = this.$store.getters;
      let list = [...globalFields, ...serviceFields];
      list = list.filter(item => {
        return item.is_searchable == true;
      });
      list.unshift({
        name: "Technician",
        id: "technician"
      });
      list.unshift({
        name: "Disposition",
        id: "disposition"
      });
      list.unshift({
        name: "Job Type",
        id: "template"
      });
      list.unshift({
        name: "Mechanical Keys",
        id: "mechkey"
      });
      list.unshift({
        name: "Insert Blade",
        id: "blade"
      });
      list.unshift({
        name: "Application Item No",
        id: "app_item_no"
      });
      list.unshift({
        name: "Stock (0)",
        id: "zero_stock"
      });
      list.unshift({
        name: "Stock (all)",
        id: "all_stock"
      });
      return list;
    },
    fieldItem() {
      return this.fields.find(item => {
        return item.id == this.field;
      });
    },
    range() {
      let { start, end } = this.dates;
      return `Period: <b>${formatDateOnly(start)} - ${formatDateOnly(end)}</b>`;
    },
    dates() {
      const vm = this;
      let updated_at = vm.date;
      let start = moment()
        .subtract(30, "days")
        .format("YYYY-MM-DDTHH:mm:ss");
      let end = vm.end(new Date());
      if (updated_at.length === 1) {
        start = vm.start(updated_at[0]);
        end = vm.end(updated_at[0]);
      }
      if (updated_at.length === 2) {
        let date1 = moment(updated_at[0]);
        let date2 = moment(updated_at[1]);
        if (date1.isBefore(date2)) {
          start = vm.start(date1);
          end = vm.end(date2);
        } else {
          start = vm.start(date2);
          end = vm.end(date1);
        }
      }
      return { start, end };
    },
    zipcodes() {
      return this.$store.getters.zipcodes;
    },
    isCarFieldOnly() {
      const carFields = ["mechkey", "blade", "app_item_no", "zero_stock", "all_stock"];
      return Array.isArray(this.appliedFields) && this.appliedFields.length > 0 && this.appliedFields.every(f => carFields.includes(f));
    },
    headers() {
      if (this.keyRows.length) {
        const l = this.keyLabel;
        const cols = [
          ["S.No", "sno"],
          ["Make", "make"],
          ["Box Location", "box"],
          [`${l} Name`.trim(), "name"],
          ["Stock", "stock"],
          [`${l} Item`.trim(), "item"]
        ];
        if (this.appliedFields.includes("app_item_no")) {
          cols.push(["Application Item No", "app_item_no"]);
        }
        return cols.map(([text, value], i) => ({
          text,
          value,
          class: "text-capitalize",
          align: "start",
          width: value === "sno" ? "70px" : undefined,
          divider: i !== cols.length - 1
        }));
      }
      const doc = this.isCarFieldOnly || (!Object.keys(this.jobs).length && this.stockRows.length)
        ? { field: "Field" }
        : { field: "Field", count: "Number of Jobs", action: "Action" };
      let list = [];
      Object.keys(doc).forEach(key => {
        list.push({
          text: doc[key],
          value: key,
          class: "text-capitalize",
          align: "start",
          divider: key !== "action"
        });
      });
      return list;
    },
    list() {
      let list = [];
      Object.keys(this.jobs).forEach(key => {
        list.push({
          field: key,
          jobs: this.jobs[key],
          count: this.jobs[key].length
        });
      });
      if (this.keyRows.length) return this.keyRows;
      return [...this.stockRows, ...list];
    }
  },
  methods: {
    start(date) {
      return moment(date)
        .startOf("day")
        .format("YYYY-MM-DDTHH:mm:ss");
    },
    end(date) {
      return moment(date)
        .endOf("day")
        .format("YYYY-MM-DDTHH:mm:ss");
    },
    reset() {
      const vm = this;
      let start = moment()
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      let end = moment().format("YYYY-MM-DD");
      vm.date = [start, end];
      vm.jobs = [];
      vm.stockRows = [];
      vm.keyRows = [];
      vm.appliedFields = [];
      vm.field = "";
    },
    findModel(fields, options, { MAKE, MAKE_UNLOCKING, MODEL }) {
      let makeName = options[MAKE] || options[MAKE_UNLOCKING] || "";
      let modelName = fields[MODEL] || "";
      let make = this.$store.getters.makes.find(
        m => m.name?.toLowerCase() === makeName.toLowerCase()
      );
      return make?.models?.find(
        m => m.name?.toLowerCase() === modelName.toLowerCase()
      ) || null;
    },

    getStockVal(model, zeroOnly = false) {
      if (!model) return null;
      let stock = model.stock;
      if (stock === undefined || stock === null || stock === "") return null;
      if (zeroOnly && Number(stock) !== 0) return null;
      return `Stock: (${stock})`;
    },
    // prox / non-prox is decided by the application item number + key category combined
    isProxModel(model) {
      return /prox/i.test(
        [model && model.app_item_no, model && model.key_category].filter(Boolean).join(" ")
      );
    },
    parseKeyStock(text) {
      const t = (text || "").toString().trim();
      const m = t.match(/^\((.*)\)/);
      let inner = m ? m[1] : "";
      const name = m ? t.replace(/^\(.*\)\s*/, "").trim() : t;
      let stock = "";
      const sm = inner.match(/(?:^|\/)\s*STK#\s*(\d*)\s*(?=\/|$)/i);
      if (sm) {
        stock = sm[1] === "" ? "" : Number(sm[1]);
        inner = inner.replace(sm[0], "").replace(/^\//, "").trim();
      }
      const prefix = /^(?:MKB#|IKB#)/i;
      let box = "";
      let item = "";
      if (prefix.test(inner)) {
        item = inner.replace(prefix, "").trim();
      } else if (inner.includes("/")) {
        const i = inner.indexOf("/");
        box = inner.slice(0, i).trim();
        item = inner.slice(i + 1).trim().replace(prefix, "").trim();
      } else {
        box = inner;
      }
      return { box, name, item, stock };
    },
    // Stock (0): stock is 0 or not set ("-"); Stock (all): every key, zero or not
    buildKeyStockRows(stockFields, selected) {
      const rows = [];
      const seen = new Set();
      const wantZero = stockFields.includes("zero_stock");
      const wantAll = stockFields.includes("all_stock");
      const sources = [];
      if (selected.includes("mechkey")) sources.push("mechanical_key");
      if (selected.includes("blade")) sources.push("emg_key");
      this.$store.getters.makes.forEach(make => {
        (make.models || []).forEach(model => {
          sources.forEach(src => {
            const text = (model[src] || "").toString().trim();
            if (!text) return;
            // mechanical keys: hide prox rows; insert blade: only prox rows
            const isProx = this.isProxModel(model);
            if (src === "mechanical_key" && isProx) return;
            if (src === "emg_key" && !isProx) return;
            const p = this.parseKeyStock(text);
            const qty = Number(p.stock) || 0;
            if (!wantAll && !(wantZero && qty === 0)) return;
            const appItemNo = selected.includes("app_item_no")
              ? (model.app_item_no || "").replace(/\s+/g, " ").trim()
              : "";
            const key = [make.name, p.box, p.name, p.item, p.stock, appItemNo].join("|").toLowerCase();
            if (seen.has(key)) return;
            seen.add(key);
            rows.push({
              make: make.name || "-",
              box: p.box || "-",
              name: p.name || "-",
              stock: p.stock === "" ? "-" : p.stock,
              item: p.item || "-",
              app_item_no: appItemNo || "-",
              field: [make.name, p.box, p.name, p.stock === "" ? "-" : p.stock, p.item].join(" | "),
              jobs: [],
              count: "-",
              catalog: true
            });
          });
        });
      });
      rows.sort((a, b) => a.make.localeCompare(b.make));
      rows.forEach((r, i) => (r.sno = i + 1));
      return rows;
    },
    buildStockRows(stockFields) {
      const rows = [];
      const seen = new Set();
      if (!stockFields.length) return rows;
      const zeroOnly = !stockFields.includes("all_stock");
      this.$store.getters.makes.forEach(make => {
        (make.models || []).forEach(model => {
          const stock = this.getStockVal(model, zeroOnly);
          if (!stock) return;
          const itemNo = (model.app_item_no || "").replace(/\s+/g, " ").trim();
          // mechanical keys: hide prox rows; insert blade: only prox rows
          const isProx = this.isProxModel(model);
          const selected = Array.isArray(this.field) ? this.field : [];
          if (!(selected.includes("mechkey") && selected.includes("blade"))) {
            if (selected.includes("mechkey") && isProx) return;
            if (selected.includes("blade") && !isProx) return;
          }
          // app item no text usually already carries "*STOCK: (n)"
          const hasStock = /stock\s*:/i.test(itemNo);
          const field = [make.name, itemNo, hasStock ? "" : stock].filter(Boolean).join(" + ");
          const key = field.replace(/\s+/g, " ").toLowerCase();
          if (seen.has(key)) return;
          seen.add(key);
          rows.push({ field, jobs: [], count: "-", catalog: true });
        });
      });
      return rows;
    },
   async submit() {
  const vm = this;
      if (vm.field == "") return vm.$alert.show("Please select field");
      let { start, end } = vm.dates;
  vm.jobs = [];
  vm.stockRows = [];
      vm.keyRows = [];
      vm.appliedFields = Array.isArray(vm.field) ? [...vm.field] : [];
      const carFields = ["mechkey", "blade", 'app_item_no', 'zero_stock', 'all_stock'];
      const stockFields = ["zero_stock", "all_stock"];
      // any stock field selected: show only the car make/model catalog, no job scan
      const hasStock = vm.field.some(f => stockFields.includes(f));
      const jobFields = hasStock ? [] : vm.field;
      const stockSel = vm.field.filter(f => stockFields.includes(f));
      // stock + mechanical key / insert blade: show key stock table
      if (hasStock && (vm.field.includes("mechkey") || vm.field.includes("blade"))) {
        vm.keyLabel = vm.field.includes("mechkey") && vm.field.includes("blade")
          ? ""
          : vm.field.includes("mechkey") ? "MK" : "IB";
        vm.keyRows = vm.buildKeyStockRows(stockSel, vm.field);
        return;
      }
      vm.stockRows = hasStock ? vm.buildStockRows(vm.field.filter(f => stockFields.includes(f))) : [];
      if (!jobFields.length) return;
      const ignoreDate = jobFields.every(f => carFields.includes(f));
      let query = ignoreDate
    ? customers
        .orderBy("created_at", "desc")
        .where("status", "in", [1, 2, 3, 5, 6, 7])
    : customers
        .orderBy("created_at", "desc")
        .where("created_at", ">=", start)
        .where("created_at", "<=", end)
        .where("status", "in", [1, 2, 3, 5, 6, 7]);
  try {
    vm.$loader.show();
        let snap = await query.get();
        let jobs = {};
        snap.docs.forEach(item => {
          let {
        fields,
        options,
        job_number,
        disposition,
        template,
        technician
          } = item.data();
          let {
        ZIPCODE,
        MAKE,
        DISPOSITION,
        TEMPLATE,
        TECHNICIAN,
        MODEL,
        MAKE_UNLOCKING
      } = customerModal;

      const vals = [];

      jobFields.forEach(field => {
        let val = "";

        if (fields[field] !== undefined) {
          val = fields[field];
        }

        if (field === MAKE) {
          val = options[field];
        }

        if (field === DISPOSITION) {
          val = vm.getOptions(disposition, "dispositions");
        }

        if (field === TEMPLATE) {
          val = vm.getOptions(template, "templates");
        }

        if (field === TECHNICIAN) {
          val = vm.getOptions(technician, "technicians");
        }

        if (field === ZIPCODE) {
          val = vm.getZip(val);
        }

        if (carFields.includes(field)) {
          const model = vm.findModel(
            fields,
            options,
            {
              MAKE,
              MAKE_UNLOCKING,
              MODEL
            }
          );

          if (!model) return;

          // mechanical keys: hide prox rows; insert blade: only prox rows
          const isProx = vm.isProxModel(model);
          if (!(jobFields.includes("mechkey") && jobFields.includes("blade"))) {
            if (jobFields.includes("mechkey") && isProx) return;
            if (jobFields.includes("blade") && !isProx) return;
          }

          if (field === "blade") {
            val = (model.emg_key || "").trim();
          }

          if (field === "mechkey") {
            val = (model.mechanical_key || "").trim();
          }

          if (field === "app_item_no") {
            val = model.app_item_no || "";
          }

          if (field === "zero_stock") {
            val = vm.getStockVal(model, true) || "";
          }

          if (field === "all_stock") {
            val = vm.getStockVal(model, false) || "";
          }
        }

        if (val) {
          vals.push(val);
        }
      });

      if (vals.length === jobFields.length) {
        const key = vals.join(" + ");

        if (!jobs[key]) {
          jobs[key] = [];
        }

        jobs[key].push(job_number);
      }
    });

    vm.jobs = jobs;

    // used in UI & PDF
    vm.onlyCarFields = ignoreDate;

    vm.$loader.hide();
  } catch (error) {
    vm.$loader.hide();
    vm.$alert.show(error.message);
  }
},
    exportPdf() {
  const vm = this;

  const doc = new jsPDF({
    orientation: "landscape"
  });

  const { start, end } = vm.dates;

  const dateRange =
    `${formatDateOnly(start)} - ${formatDateOnly(end)}`;

  const selectedFields = vm.field
    .map(id => {
      const field = vm.fields.find(f => f.id === id);
      return field ? field.name : id;
    })
    .join(", ");

  const carFields = [
    "mechkey",
    "blade",
    "app_item_no",
    "zero_stock",
    "all_stock"
  ];

  const onlyCarFields = vm.field.every(f =>
    carFields.includes(f)
  );

  doc.setFontSize(14);
  doc.text("Search Engine Results", 14, 15);

  doc.setFontSize(10);
  //doc.text(`Date Range: ${dateRange}`, 14, 22);
  doc.text(`Fields: ${selectedFields}`, 14, 28);

  let head = [];
  let body = [];

  if (vm.keyRows.length) {
    head = [vm.headers.map(h => h.text)];
    body = vm.keyRows.map(r => vm.headers.map(h => r[h.value]));
  } else if (onlyCarFields) {
    head = [["Field"]];

    body = vm.list.map(item => [
      item.field
    ]);
  } else {
    head = [["Field", "Number of Jobs", "Job Numbers"]];

    body = vm.list.map(item => [
      item.field,
      item.count,
      item.jobs.join(", ")
    ]);
  }

  doc.autoTable({
    startY: 33,
    head,
    body,
    styles: {
      fontSize: 8,
      cellPadding: 2
    },
    headStyles: {
      fillColor: [41, 128, 185]
    }
  });

  doc.save(
    `search-results-${dateRange}.pdf`
  );
},
    getOptions(val, store) {
      const vm = this;
      let item = vm.$store.getters[store].find(item => {
        return item.id == val;
      });
      return item != null ? item.name : undefined;
    },
    getZip(val) {
      const vm = this;
      let zip = vm.zipcodes.find(item => {
        return item.id == val;
      });
      if (zip != null) {
        let { zipcode, community, zone } = zip;
        val = `${zipcode} / ${community} / ${zone}`;
      } else {
        val = undefined;
      }
      return val;
    }
  }
};
</script>

<style></style>
